module.exports = __webpack_public_path__ + "assets/img/white_holly-069ef41b.jpg";